import { render } from "./CredibilityPanel.vue?vue&type=template&id=549d945e&scoped=true"
import script from "./CredibilityPanel.vue?vue&type=script&lang=js"
export * from "./CredibilityPanel.vue?vue&type=script&lang=js"

import "./CredibilityPanel.vue?vue&type=style&index=0&id=549d945e&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549d945e"]])

export default __exports__